
// import 'bootstrap';
import ready from './utils';
import initSlickCarousel from './components/slickCarousel';
import initAOS from './components/AOS';
import initInputNumbers from './components/inputNumbers';
import initDatepicker from './components/datepicker';
import initMobileMenu from "./components/mobileMenu";
import initHoverCards from "./components/hoverCards";
import initAccordionMedia from "./components/accordionMedia";
import initStickyScrollBlock from "./components/stickyScrollBlock";
import initAnchors from "./components/anchors";
import initAjaxPosts from "./components/ajaxPosts";
// import initFullCalendar from "./components/fullCalendar";
import initFancybox from "./components/fancybox";
import initSwiper from "./components/swiper";
import initContactForm7 from './components/contactForm7';
import initFormHero from './components/formHero';
import initStickyHeaderHelper from "./components/stickyHeaderHelper";
import initAccordionScrolling from "./components/accordionScrolling";

ready(() => {
    // Load functionality-specific js here
    document.body.classList.add('loaded');
    initAOS();
    initInputNumbers();
    initMobileMenu();
    initHoverCards();
    initAccordionMedia();
    initAccordionScrolling();
    // initFullCalendar();
    initSwiper();
    initSlickCarousel();
    initDatepicker();
    initStickyScrollBlock();
    initAnchors();
    initAjaxPosts();
    initFancybox();
    initContactForm7();
    initFormHero();
    initStickyHeaderHelper();
});

window.addEventListener('load', () => {
    const hash = window.location.href.split('#')[1];
    const header = document.querySelector('header.header');

    if (hash && document.getElementById(hash)) {
        window.scrollTo({
            top: document.getElementById(hash).offsetTop,
            behavior: "smooth",
        })
    }
})


